exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".activity-feed-item a{color:#383c43!important}activity-feed-item:last-of-type .activity-feed-item{border-bottom:0!important}", "", {"version":3,"sources":["/./src/app/components/activityFeedItem/src/app/components/activityFeedItem/activityfeeditem.scss"],"names":[],"mappings":"AAAA,sBAEI,uBAAyB,CAC1B,AAGH,oDAEI,yBAA2B,CAC5B","file":"activityfeeditem.scss","sourcesContent":[".activity-feed-item {\n  a {\n    color: #383c43 !important;\n  }\n}\n\nactivity-feed-item:last-of-type {\n  .activity-feed-item {\n    border-bottom: 0 !important;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/activityFeedItem/activityfeeditem.scss
// module id = 1008
// module chunks = 0